import React, { JSX } from 'react';
import { CenteredRing } from '../CenteredRing/CenteredRing';
import { Impressum } from '../Impressum';
import { Navigation } from '../Navigation';
import './Page.css';
import { TopNavigation } from './TopNavigation';

type Props = {
  readonly title: string;
  readonly loading?: boolean;
  readonly showMenu?: boolean;
  readonly children: React.ReactNode;
};

export function Page({ title, loading = false, showMenu = true, children }: Props): JSX.Element {
  return (
    <div className="page">
      <TopNavigation />
      <div className="page__area">
        <Navigation show={showMenu} />

        <div className="page__wrapper">
          <div className="page__main">
            <div className="page__title">{title}</div>
            <div className="page__content">{!loading ? children : <CenteredRing />}</div>
            <Impressum />
          </div>
        </div>
      </div>
    </div>
  );
}
